/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup';
import RatingInfograph from './RatingInfograph';

const RatingInfoV5 = (props) => {
	const {
		isMobile,
		type = 'ratingInfo',
		showPopup,
		closePopup,
		rootClass,
		rightAlign,
	} = props;

	const desktopAlignStyles = rightAlign
		? { cursor: 'auto', right: '0' }
		: { cursor: 'auto', left: '0' };

	return (
    <>
        {showPopup && (
        <div className={`info-root ${rootClass}`}>
            {isMobile ? (
                <Popup
                    onCloseClick={closePopup}
                    config={{
								noPadding: true,
								fullScreen: false,
								topGradient: false,
								scrollable: true,
								noHeader: true,
								style: {
									cursor: 'auto',
								},
							}}
                >
                    <RatingInfograph
                        isMobile={isMobile}
                        type={type}
                        closePopUp={closePopup}
                    />
                </Popup>
					) : (
    <div
        className={`info-container below-anchor`}
        style={{ ...desktopAlignStyles }}
    >
        <RatingInfograph
            isMobile={isMobile}
            type={type}
            closePopUp={closePopup}
        />
    </div>
					)}
        </div>
			)}
    </>
	);
};

RatingInfoV5.defaultProps = {
	type: 'ratingInfo',
	showPopup: false,
	rightAlign: false,
	rootClass: '',
};

RatingInfoV5.propTypes = {
	isMobile: PropTypes.bool.isRequired,
	type: PropTypes.string,
	rootClass: PropTypes.string,
	showPopup: PropTypes.bool,
	closePopup: PropTypes.func.isRequired,
	rightAlign: PropTypes.bool,
};

export default RatingInfoV5;
